import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=96cb651c&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=96cb651c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cb651c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96cb651c')) {
      api.createRecord('96cb651c', component.options)
    } else {
      api.reload('96cb651c', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=96cb651c&scoped=true&", function () {
      api.rerender('96cb651c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25AQakYKHaSyn/JS/comp/CookieBox.vue"
export default component.exports